export default __webpack_public_path__ + "static/media/news-bg-two.6e3d0830.jpg";